import { createSlice } from "@reduxjs/toolkit";
import { fetchPropertyImage } from "../thunks/propertyImagesActions";

const initialState = {
  imageUrls: {},
  loading: false,
  error: null,
};

const propertyImagesSlice = createSlice({
  name: "propertyImages",
  initialState,
  reducers: {
    clearImages: (state) => {
      state.imageUrls = {};
      state.loading = false;
      state.error = null;
    },
    setImageUrl: (state, action) => {
      const { propertyId, imageUrl } = action.payload;
      console.log('Redux: Setting image URL:', { propertyId, imageUrl });
      state.imageUrls[propertyId] = imageUrl;
      console.log('Redux: Updated imageUrls:', state.imageUrls);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPropertyImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPropertyImage.fulfilled, (state, action) => {
        state.loading = false;
        const { propertyId, imageUrl } = action.payload;
        if (imageUrl) {
          state.imageUrls[propertyId] = imageUrl;
        }
      })
      .addCase(fetchPropertyImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearImages, setImageUrl } = propertyImagesSlice.actions;
export default propertyImagesSlice.reducer;